import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import SkeletonLoading from 'helpers/loading/skeletonLoading';

const Component = lazy(() => import('components/integration-data-management-menu'));

const IntegrationDataManagementMenu = (props) => (
  <CWOConfigProvider>
    <Suspense fallback={<SkeletonLoading rows={3} />}>
      <Component {...props} />
    </Suspense>
  </CWOConfigProvider>
);

export default IntegrationDataManagementMenu;
